import createParallax from "$comp/parallax/parallax";

let pagebreakteaser = {

    init: () =>{

        pagebreakteaser.name =  '.ce_rsce_pagebreakteaser';
        pagebreakteaser.elements = document.querySelectorAll(pagebreakteaser.name);
        pagebreakteaser.attemptActionIfNotEmpty(pagebreakteaser.ready);

        window.addEventListener('load', () => {
            pagebreakteaser.attemptActionIfNotEmpty(pagebreakteaser.loaded);
        });

        return pagebreakteaser;
    },

    attemptActionIfNotEmpty: function (action) {
        if (pagebreakteaser.elements.length > 0) {
            action();
        }
    },

    ready : () => {
        pagebreakteaser.elements.forEach((element) => {
            // const layer_1 = createParallax(element.querySelector('.ce_rsce_pagebreakteaser__image'), {speed: 5, axis: 'y', maxTranslate: 80});
            // const layer_2 = createParallax(element.querySelector('.ce_rsce_pagebreakteaser__content'), {speed: 2, axis: 'y', maxTranslate: 50});
        });

    },

    loaded : () => {

    }

};

export default pagebreakteaser.init();
